export default __webpack_public_path__ + "static/media/cup.382c23fc.png";